module.exports = __webpack_public_path__ + "static/wt-modal-966717e662bf4a335aba8872e970c61e.png";